import { Box, Flex, Icon, Tag } from '@/ui';

type Props = {
  labels: { id: string; text: string }[];
  selectedIds: string[];
  onToggle: (labelId: string) => void;
};

// Pill-toggle list shared by the Who and Labels tabs. Unselected pills are
// neutral outlines; selected pills get the magicPurple wash.
export const FilterLabelList = ({ labels, selectedIds, onToggle }: Props) => (
  <Flex direction="column" gap="2">
    {labels.map((label) => {
      const isSelected = selectedIds.includes(label.id);

      return (
        <Box key={label.id}>
          <Tag
            _hover={{ bg: isSelected ? 'magicPurple.25' : 'rgba(0,0,0,0.03)' }}
            as="button"
            bgColor={isSelected ? 'magicPurple.25' : 'white'}
            borderColor={isSelected ? 'magicPurple.200' : 'line.DEFAULT'}
            borderRadius="full"
            borderWidth="1px"
            color={isSelected ? 'magicPurple.700' : 'ink.soft'}
            h="34px"
            lineHeight="normal"
            px="3"
            shadow="none"
            size="md"
            type="button"
            variant="outline"
            _focusVisible={{
              outline: '1px solid',
              outlineColor: 'magicPurple.400',
              outlineOffset: -1,
            }}
            onClick={() => onToggle(label.id)}
          >
            <Flex align="center" gap="2" overflow="hidden">
              <Box
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {label.text}
              </Box>
              {isSelected && (
                <Icon color="magicPurple.500" icon="Checkmark" size={3.5} />
              )}
            </Flex>
          </Tag>
        </Box>
      );
    })}
  </Flex>
);
